import React from 'react'
import { PaymentTypeItem } from '../PaymentTypeItem'

export function ListPaymentTypes({ payments }) {
  return (
    <>
      {payments?.map((payment, index) => (
        <PaymentTypeItem
          key={`payment_type_${payment?.PaymentName?.toLowerCase()}_${index}`}
          payment={payment}
        />
      ))}
    </>
  )
}
